module.exports = __webpack_public_path__ + "img/location.da02d124.svg";